import React from 'react';
import { Camera, Video, Maximize2, Aperture, Award, Users, Clock, Shield } from 'lucide-react';

const AboutBlock = () => {
    const products = [
        { icon: Camera, title: 'Камеры', description: 'Профессиональные зеркальные и беззеркальные камеры' },
        { icon: Maximize2, title: 'Штативы', description: 'Надежные штативы для любых условий съемки' },
        { icon: Video, title: 'Видеокамеры', description: 'Современное оборудование для видеосъемки' },
        { icon: Aperture, title: 'Объективы', description: 'Широкий выбор оптики для всех задач' },
    ];

    const features = [
        { icon: Award, title: 'Гарантия качества', text: 'Официальная гарантия на всю технику' },
        { icon: Users, title: 'Экспертная помощь', text: 'Профессиональные консультации' },
        { icon: Clock, title: 'Быстрая доставка', text: 'Доставим заказ в кратчайшие сроки' },
        { icon: Shield, title: 'Надежность', text: '10+ лет на рынке фототехники' },
    ];

    return (
        <section className="relative py-24 overflow-hidden">
            <div className="absolute inset-0">
                <div className="absolute top-1/4 left-1/4 w-[400px] h-[400px] bg-purple-600/10 rounded-full blur-3xl animate-pulse"></div>
                <div className="absolute bottom-1/4 right-1/4 w-[400px] h-[400px] bg-blue-600/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
            </div>

            <div className="container mx-auto px-4 relative z-10">
                <div className="text-center mb-16">
                    <span className="inline-block px-4 py-2 bg-purple-700/20 text-purple-300 text-sm font-medium rounded-full mb-4">
                        О нас
                    </span>
                    <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
                        Ваш надежный партнер в мире фототехники
                    </h2>
                    <p className="text-gray-400 max-w-2xl mx-auto text-lg">
                        Мы предлагаем профессиональное оборудование для фотографов и видеографов любого уровня
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-20">
                    {products.map((product, index) => (
                        <div
                            key={index}
                            className="group relative bg-gray-800/50 backdrop-blur-sm rounded-2xl p-6 border border-gray-700 hover:border-purple-500 transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-purple-500/20"
                        >
                            <div className="w-14 h-14 bg-gradient-to-br from-purple-600 to-blue-600 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                                <product.icon className="w-7 h-7 text-white" />
                            </div>
                            <h3 className="text-xl font-bold text-white mb-2">{product.title}</h3>
                            <p className="text-gray-400 text-sm">{product.description}</p>
                        </div>
                    ))}
                </div>

                <div className="max-w-4xl mx-auto mb-20">
                    <div className="bg-gray-800/30 backdrop-blur-sm rounded-3xl p-8 md:p-12 border border-gray-700">
                        <p className="text-gray-300 text-lg leading-relaxed mb-6">
                            Мы специализируемся на продаже профессиональной фото и видеотехники. За годы работы мы заслужили доверие тысяч клиентов, предлагая только оригинальное оборудование от ведущих мировых производителей.
                        </p>
                        <p className="text-gray-300 text-lg leading-relaxed">
                            Наша команда состоит из опытных специалистов, которые помогут вам выбрать идеальное оборудование для решения любых творческих задач. Мы не просто продаем технику — мы помогаем воплощать ваши идеи в жизнь.
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                    {features.map((feature, index) => (
                        <div
                            key={index}
                            className="text-center p-6 rounded-2xl bg-gray-800/30 backdrop-blur-sm border border-gray-700 hover:border-purple-500 transition-all duration-300 hover:scale-105"
                        >
                            <div className="w-16 h-16 bg-gradient-to-br from-purple-600 to-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                                <feature.icon className="w-8 h-8 text-white" />
                            </div>
                            <h3 className="text-lg font-bold text-white mb-2">{feature.title}</h3>
                            <p className="text-gray-400 text-sm">{feature.text}</p>
                        </div>
                    ))}
                </div>

                <div className="text-center mt-16">
                    <button className="px-8 py-4 bg-gradient-to-r from-purple-600 to-blue-600 text-white font-semibold rounded-xl hover:scale-105 transition-transform duration-300 shadow-lg shadow-purple-500/30">
                        Связаться с нами
                    </button>
                </div>
            </div>
        </section>
    );
};

export default AboutBlock;